export function getIconPosition(
    button: HTMLElement,
    parentScrollContainer: HTMLElement | typeof window,
): number {
    const buttonRect = button.getBoundingClientRect();

    if (parentScrollContainer === window) {
        const viewportHeight = window.innerHeight;
        let start = 0;
        let end = 0;

        if (!(buttonRect.height === 0 || buttonRect.top > viewportHeight || buttonRect.bottom < 0)) {
            start = buttonRect.top < 0 ? -buttonRect.top : 0;
            end = Math.min(buttonRect.bottom, viewportHeight) - buttonRect.top;
        }

        const centerOfVisibleYPart = start + (end - start) / 2;

        return Math.max(
            0,
            Math.min(
                buttonRect.height,
                centerOfVisibleYPart,
            ),
        );
    } else {
        const containerRect = (parentScrollContainer as HTMLElement).getBoundingClientRect();
        const buttonTopRelativeToContainer = buttonRect.top - containerRect.top;
        const visibleStart = Math.max(0, -buttonTopRelativeToContainer);
        const visibleEnd = Math.min(
            buttonRect.height,
            containerRect.height - buttonTopRelativeToContainer,
        );

        // Calculate center of visible part
        const centerOfVisiblePart = visibleStart + (visibleEnd - visibleStart) / 2;

        // Ensure the icon stays within button boundaries
        return Math.max(
            0,
            Math.min(
                buttonRect.height,
                centerOfVisiblePart,
            ),
        );
    }
}
